import { Moment } from 'moment';
import { ITenant } from './tenant.model';

export interface IDomain {
  id?: number;
  name?: string;
  description?: string;
  createdBy?: string;
  createdDate?: Moment;
  lastModifiedBy?: string;
  lastModifiedDate?: Moment;
  tenant?: ITenant;
}

export const defaultValue: Readonly<IDomain> = {};
